import {AppInsightsAdapter} from '@hconnect/common/logging'
import {createRoot} from 'react-dom/client'

import {App} from './App'
import {initLocalization} from './localization'

initLocalization()

AppInsightsAdapter.init()
AppInsightsAdapter.allowTracking()

const rootElement = document.getElementById('root')
const root = createRoot(rootElement as HTMLElement)

root.render(<App />)
